export default "__VITE_ASSET__jelgIlUe__"